<template>
  <div class="product-header-container">
    <div class="smart-header" :class="{ 'header-hidden': headerHidden && !menuOpen }">
      <Header
        theme="light"
        @menu-open="onMenuOpen"
        @menu-close="onMenuClose"
        style="transition: transform 0.3s ease-in-out;"
        :icon-color="iconColor"
      />
    </div>

    <div class="content-wrapper font-apercu-medium">
      <div class="sticky-placeholder" v-if="isSticky" style="height: 60rem;"></div>
      <div class="sticky-bar" :class="{ 'is-fixed': isSticky }">
        <div class="header-row">
          <h1 class="page-title font-apercu-medium">{{productName}}</h1>
          <span class="product-count">{{ totalCount }} Products</span>
        </div>
      </div>

      <p class="page-description">
        {{ productDescription }}
      </p>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'

export default {
  name: 'ProductHeader',
  components: {
    Header
  },
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    productName: {
      type: String,
      default: 'ALL Products' 
    },
    productDescription: {
      type: String,
      default: 'All Product Displays'
    },
    iconColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      headerHidden: false,
      lastScrollTop: 0,
      isSticky: false,
      menuOpen: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    onMenuOpen() {
      this.menuOpen = true
      this.$emit('menu-open')
    },
    onMenuClose() {
      this.menuOpen = false
      this.$emit('menu-close')
    },
    handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop

      // Sticky logic: trigger when scroll passes the top padding (180rem)
      this.isSticky = currentScroll > 175

      // Header logic: only show when at the very top
      // If we are scrolled down at all, hide the header
      this.headerHidden = currentScroll > 0

      this.lastScrollTop = currentScroll
    }
  }
}
</script>

<style scoped>
.product-header-container {
  width: 100%;
  position: relative;
  background-color: #FBFBFB;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  border-bottom: 1rem solid rgba(0,0,0,1);
}

.smart-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #FBFBFB;
  transition: transform 0.3s ease-in-out;
}

.header-hidden {
  display: none;
}

.content-wrapper {
  /* Give enough space for the fixed header */
  padding: 275rem 40rem 40rem 40rem;
  max-width: 100%;
  margin: 0 auto;
}

.sticky-bar {
  padding-right: 23rem;
  padding-left: 23rem;
  position: relative;
  z-index: 999;
  background-color: #FBFBFB;
  padding-bottom: 20rem;
}

.sticky-bar.is-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 22rem 40rem; /* Add top padding and side padding to match layout */
  box-sizing: border-box;
  box-shadow: 0 1rem 0 rgba(0,0,0,0.05); /* Optional subtle separator */
}

@media (max-width: 768px) {
  .sticky-bar.is-fixed {
    padding: 20rem 20rem;
  }
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.page-title {
  font-size: 24rem;
  font-weight: 500;
  color: #000;
  margin: 0;
}

.product-count {
  font-size: 16rem;
  font-weight: 500;
  color: #000;
}

.page-description {
  font-size: 16rem;
  color: #000;
  font-weight: 500;
  max-width: 600rem;
  margin: 0;
  padding-left: 23rem;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 215rem 20rem 30rem 20rem;
  }

  .header-row {
    flex-direction: column;
    gap: 10rem;
  }

  .product-count {
    order: -1;
    /* Move count to top or keep below? usually count is small info */
    /* Or keep it as is */
  }
}
</style>
